/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.
*
*/

(function() {

  // -----------------------------------------
  // Variant Change
  // -----------------------------------------

  document.addEventListener('theme:variant:change', function(event) {

    var variant = event.detail.variant;
    var container = event.target;

    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);

      console.log('Variant —————————— ↓');
      console.log(variant);
    }

  });


  // -----------------------------------------
  // Cart Change
  // -----------------------------------------

  document.addEventListener('theme:cart:change', function(event) {

    var cart = event.detail.cart;

    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }

  });


  // -----------------------------------------
  // Cart Init
  // -----------------------------------------

  document.addEventListener('theme:cart:init', function(event) {

    console.log('theme:cart:init');
    console.log(event);

  });


  // -----------------------------------------
  // Automatically Open Cart Drawer
  // After Add To Cart
  // -----------------------------------------

  document.addEventListener('theme:cart:popdown', function() {

    var cartDrawer = document.querySelector(
      '[data-drawer="drawer-cart"]'
    );

    if (!cartDrawer) return;

    setTimeout(function() {

      /*
       * Only open if drawer is currently closed
       */
      if (!cartDrawer.classList.contains('drawer--visible')) {

        cartDrawer.dispatchEvent(
          new CustomEvent('theme:drawer:open', {
            bubbles: false
          })
        );

      }

    }, 300);

  });


  // -----------------------------------------
  // Scroll Events
  // -----------------------------------------

  document.addEventListener('theme:scroll', function(event) {
    console.log(event);
  });

  document.addEventListener('theme:scroll:up', function(event) {
    console.log(event);
  });

  document.addEventListener('theme:scroll:down', function(event) {
    console.log(event);
  });


  // -----------------------------------------
  // Resize Event
  // -----------------------------------------

  document.addEventListener('theme:resize', function(event) {
    console.log(event);
  });


  // -----------------------------------------
  // Scroll Lock / Unlock
  // -----------------------------------------

  /*
  document.dispatchEvent(
    new CustomEvent('theme:scroll:lock', {
      bubbles: true,
      detail: scrollableInnerElement
    })
  );

  document.dispatchEvent(
    new CustomEvent('theme:scroll:unlock', {
      bubbles: true
    })
  );
  */


})();